import axios from 'axios'
import { PaymentRequestPayload } from 'publisher/hooks/payment/usePaymentSubmit'
import request from 'publisher/utils/request'
import { PageId } from '../store/page/PageStateInterface'
import { PurchaseProcessId } from '../store/payment/PaymentStateInterface'

export interface CreateOrderResponse {
  orderId: string
  redirectUrl: string // will be removed
  redirect?: string
  options: {
    paypalOrderId: string
    hash: string
    paypalLink?: string
  }
  isBump?: boolean
}

export interface CreateSubscriptionResponse {
  orderId: string
  redirectUrl: string // will be removed
  redirect?: string
  options: {
    paypalSubscriptionId: string
    paypalPlanId: string
    hash: string
    paypalLink?: string
  }
  isBump?: boolean
}

export const buyMainOffer = (
  pageId: PageId,
  body: Record<string, PaymentRequestPayload>,
) => axios.post(`/api/purchase-service/buy-main-offer/${pageId}`, body)

export const continuePurchase = <T>(url: string) =>
  request.get<T>(url).then(res => {
    // If the requested URL differs from the response URL, a redirect response received, so need to redirect the user
    if (url !== res.request?.responseURL) {
      window.location.assign(res.request.responseURL)
      return
    }
    return res
  })

export interface CaptureOrderBody {
  paypalOrderId?: string
  paypalPaymentId?: string | null
  paypalPayerId?: string | null
  facilitatorAccessToken?: string
  paymentSource: string
  hash: string
}

interface CaptureOrderResponse {
  redirectLink: string // will be removed
  redirect?: string
}

export const captureOrder = (body: CaptureOrderBody) =>
  axios.post<CaptureOrderResponse>(
    '/api/payment/integration/paypal-rest/order/capture',
    body,
  )

interface ValidateSubscriptionBody {
  paypalSubscriptionId: string
  hash: string
}

interface ValidateSubscriptionResponse {
  redirectLink: string // will be removed
  redirect?: string
}

export const validateSubscription = (body: ValidateSubscriptionBody) =>
  axios.post<ValidateSubscriptionResponse>(
    '/api/payment/integration/paypal-rest/subscription/validate',
    body,
  )

export type BuyUpsellBody =
  | {
      product: {
        id: number
        quantity: number
        variant?: string
      }
      offerPricePlan?: never
      agree?: never
    }
  | {
      product?: never
      offerPricePlan?: number
      agree: true
    }

interface BuyUpsellParams {
  pageId: number
  purchaseProcessId: PurchaseProcessId
  body: BuyUpsellBody
}

interface BuyUpsellResponse {
  redirect: string
  options: {
    hash: string
    paypalOrderId?: string
    paypalSubscriptionId?: string
  }
}

export const buyUpsell = ({
  pageId,
  purchaseProcessId,
  body,
}: BuyUpsellParams) => {
  return axios.post<BuyUpsellResponse>(
    `/api/purchase-service/buy-upsell/${pageId}/${purchaseProcessId}`,
    {
      upsell_payment_form: body,
    },
  )
}
